// Local translations
export const T = {
  en_GB: {
    downloadFailed: "Could not open the document. Please try again.",
  },
  nb_NO: {
    downloadFailed: "Kunne ikke åpne dokumentet. Vennligst prøv igjen.",
  },
} as const;
